// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"341cdb9f","453":"d77375d2"}[chunkId] + ".chunk.js";
};